import { useEffect, useState } from "react";
import APIS from "../../constant/EndPoint";
import Spinner from "../Reusable/Spinner";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../../customHooks/useDebounceHook";
import ChargeTableSkeleton from "../Reusable/ChargeTableSkeleton";

const DeliveryChargeTable = (props: any) => {
  const {
    localServiceBranch,
    localServiceType,
    localProductType = [],
    merchantId,
    delivery_charge_template = null,
  } = props;
  const Product_type = localProductType
    ?.map((item: any) => item?.value)
    ?.join(",");
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);
  const { data: deliveryChargeData, isLoading: DeliveryChargeLoading } =
    useGetHook({
      queryKey: [
        "delivery-charge",
        `delivery-charge-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}`,
      ],
      url: APIS.DELIVERY_CHARGE,
      params: {
        branch: localServiceBranch,
        localServiceType: localServiceType,
        product_type: Product_type,
        merchant: merchantId,
        delivery_charge_template: delivery_charge_template,
        search: debounceSearch,
      },
    });

  const handleSearch = (value: string) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  return (
    <div className={tw`w-full overflow-auto min-h-10`}>
      {DeliveryChargeLoading ? (
        <ChargeTableSkeleton />
      ) : (
        <>
          <div className={tw`w-52`}>
            <input
              type="text"
              placeholder="Search"
              value={searchQuery ?? ""}
              onChange={(e) => handleSearch(e?.target?.value)}
              className={tw`border w-full border-1 border-primary focus:outline-none p-1 my-1`}
            />
          </div>
          <div className={tw`w-full overflow-x-auto`}>
            <table className={tw`my-2 w-full `}>
              <thead className={tw`text-justify`}>
                <tr>
                  <th className={tw`whitespace-nowrap pr-8`}>
                    Destination City
                  </th>
                  <th className={tw`whitespace-nowrap px-8`}> Contact</th>
                  <th className={tw`whitespace-nowrap px-8`}> District</th>
                  <th className={tw`whitespace-nowrap px-8`}> Covered Area</th>
                  {deliveryChargeData?.header?.map(
                    (item: any, index: number) => (
                      <th key={`product-type-${index}`} className={tw`px-8`}>
                        {item?.name}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {deliveryChargeData?.body?.map((productType: any) => (
                  <tr
                    key={`service-city-${productType?.location_id}`}
                    className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 border `}
                  >
                    <td className={tw`pr-8 py-2`}>{productType?.name}</td>
                    <td
                      key={`service-city-${productType?.location_id}`}
                      className={tw`px-8 py-2`}
                    >
                      {productType?.branch_contact}
                    </td>
                    <td
                      key={`service-city-${productType?.location_id}`}
                      className={tw`px-8 py-2 uppercase`}
                    >
                      {productType?.district ?? "N/A"}
                    </td>
                    <td
                      key={`service-city-${productType?.location_id}`}
                      className={tw`px-8 py-2 uppercase text-sm `}
                    >
                      {productType?.covered_area ?? "N/A"}
                    </td>
                    {productType?.rate?.map((item: any) => (
                      <td
                        key={`rate-${crypto.randomUUID()}`}
                        className={tw`px-8 py-2`}
                      >
                        {item}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default DeliveryChargeTable;
